import SearchFilterInput from './SearchFilterInput'

export default SearchFilterInput
